// Import English translations
import enAbsences from './en/absences.json';
import enAgenda from './en/agenda.json';
import enAroundTheWorld from './en/around-the-world.json';
import enAuth from './en/auth.json';
import enBusiness from './en/business.json';
import enChat from './en/chat.json';
import enChatbot from './en/chatbot.json';
import enCommon from './en/common.json';
import enDemo from './en/demo.json';
import enErrors from './en/errors.json';
import enHomepage from './en/homepage.json';
import enInfo from './en/info.json';
import enMenu from './en/menu.json';
import enNavigation from './en/navigation.json';
import enNews from './en/news.json';
import enNotes from './en/notes.json';
import enNotifications from './en/notifications.json';
import enPages from './en/pages.json';
import enPartnershipUniversities from './en/partnershipUniversities.json';
import enProfile from './en/profile.json';
import enQuickSearch from './en/quickSearch.json';
import enRooms from './en/rooms.json';
import enRoutes from './en/routes.json';
import enSearch from './en/search.json';
import enSettings from './en/settings.json';
import enShop from './en/shop.json';
import enStudent from './en/student.json';
import enWardMenu from './en/wardMenu.json';
import enLiaisonDocument from './en/liaison-document.json';

// Import French translations
import frAbsences from './fr/absences.json';
import frAgenda from './fr/agenda.json';
import frAroundTheWorld from './fr/around-the-world.json';
import frAuth from './fr/auth.json';
import frBusiness from './fr/business.json';
import frChat from './fr/chat.json';
import frChatbot from './fr/chatbot.json';
import frCommon from './fr/common.json';
import frDemo from './fr/demo.json';
import frErrors from './fr/errors.json';
import frHomepage from './fr/homepage.json';
import frInfo from './fr/info.json';
import frMenu from './fr/menu.json';
import frNavigation from './fr/navigation.json';
import frNews from './fr/news.json';
import frNotes from './fr/notes.json';
import frNotifications from './fr/notifications.json';
import frQuickSearch from './fr/quickSearch.json';
import frPartnershipUniversities from './fr/partnershipUniversities.json';
import frPages from './fr/pages.json';
import frProfile from './fr/profile.json';
import frRooms from './fr/rooms.json';
import frRoutes from './fr/routes.json';
import frSearch from './fr/search.json';
import frSettings from './fr/settings.json';
import frShop from './fr/shop.json';
import frStudent from './fr/student.json';
import frWardMenu from './fr/wardMenu.json';
import frLiaisonDocument from './fr/liaison-document.json';
// Merge all translations for each locale
const en = {
  ...enAbsences,
  ...enAgenda,
  ...enAroundTheWorld,
  ...enAuth,
  ...enBusiness,
  ...enChat,
  ...enChatbot,
  ...enCommon,
  ...enDemo,
  ...enErrors,
  ...enHomepage,
  ...enInfo,
  ...enMenu,
  ...enNavigation,
  ...enNews,
  ...enNotes,
  ...enNotifications,
  ...enQuickSearch,
  ...enPartnershipUniversities,
  ...enPages,
  ...enProfile,
  ...enRooms,
  ...enRoutes,
  ...enSearch,
  ...enSettings,
  ...enShop,
  ...enStudent,
  ...enWardMenu,
  ...enLiaisonDocument,
};

const fr = {
  ...frAbsences,
  ...frAgenda,
  ...frAroundTheWorld,
  ...frAuth,
  ...frBusiness,
  ...frChat,
  ...frChatbot,
  ...frCommon,
  ...frDemo,
  ...frErrors,
  ...frHomepage,
  ...frInfo,
  ...frMenu,
  ...frNavigation,
  ...frNews,
  ...frNotes,
  ...frNotifications,
  ...frQuickSearch,
  ...frPages,
  ...frPartnershipUniversities,
  ...frProfile,
  ...frRooms,
  ...frRoutes,
  ...frSearch,
  ...frSettings,
  ...frShop,
  ...frStudent,
  ...frWardMenu,
  ...frLiaisonDocument,
};

const locales = {
  en,
  fr,
};

export type Locale = keyof typeof locales;

export default locales;
